<ng-container *ngIf="open && currentStep as step">
  <div class="tour-root" role="dialog" aria-label="Rondleiding">

    <div *ngIf="targetRect; else fullDim"
         class="tour-spotlight"
         [style.top]="spotlightStyle()?.['top']"
         [style.left]="spotlightStyle()?.['left']"
         [style.width]="spotlightStyle()?.['width']"
         [style.height]="spotlightStyle()?.['height']">
    </div>

    <ng-template #fullDim>
      <div class="tour-full-dim"></div>
    </ng-template>

    <div class="tour-tooltip"
         [style.top]="tooltipStyle['top']"
         [style.left]="tooltipStyle['left']"
         [style.width]="tooltipStyle['width']">
      <div class="tour-tooltip-header">
        <span class="tour-step-index">
          Stap {{ stepIndex + 1 }} van {{ steps.length }}
        </span>
        <button type="button"
                class="tour-close-btn"
                aria-label="Sluiten"
                (click)="close(true)">
          &times;
        </button>
      </div>

      <h3 class="tour-title">{{ step.title }}</h3>
      <p class="tour-content">{{ step.content }}</p>

      <div class="tour-actions">
        <button type="button" class="tour-skip" (click)="close(true)">Overslaan</button>
        <div class="tour-nav">
          <button *ngIf="stepIndex > 0"
                  type="button"
                  class="tour-btn-prev"
                  (click)="prev()">Vorige</button>
          <button type="button"
                  class="tour-btn-next"
                  (click)="next()">
            {{ stepIndex >= steps.length - 1 ? 'Klaar' : 'Volgende' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<button *ngIf="!open && steps.length"
        type="button"
        class="tour-reopen-btn"
        [attr.aria-label]="reopenLabel"
        [title]="reopenLabel"
        (click)="reopen()">
  ?
</button>
